module.exports = __webpack_public_path__ + "static/media/Cuadro clasificacion documental.23b324a9.pdf";